import { createTheme } from '@one-thd/sui-atomic-components';

const BlackFriday2026SecondaryTwo = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

BlackFriday2026SecondaryTwo.palette['--sui-palette-background-primary'] = '173 170 170';

export { BlackFriday2026SecondaryTwo };